// extracted by mini-css-extract-plugin
export default {"container":"PassengerHeader_container__-Vebn","centered":"PassengerHeader_centered__ynujD","invite_button":"PassengerHeader_invite_button__BdkIL"};